import { TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useStyles } from './PrivateOfferDimensions.styles'
import { KeyValue } from '../../../modules/privateOffer/privateOfferCreation/types'
import { Dimension } from '../../../modules/privateOffer/types'
import { getRandom, preventEventForKeys } from '@labrav/common'
import { isEmpty } from 'lodash'
import clsx from 'clsx'
import {
  getAdditionalDimensionPriceKey,
  getAdditionalDimensionValue,
} from './utils'

export type AdditionalDimensionsRowProps = {
  additionalDimension: Dimension
  updateDimensions: (data: KeyValue) => void
  errors: Record<string, unknown>
  isResale: boolean
}

export const AdditionalDimensionsRow = React.memo(
  ({
    additionalDimension,
    updateDimensions,
    errors,
    isResale,
  }: AdditionalDimensionsRowProps) => {
    const { classes } = useStyles()
    const [randomKey, setRandomKey] = useState<number>(getRandom())
    useEffect(() => {
      setRandomKey(getRandom())
    }, [])
    const handleChange =
      (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        updateDimensions({ key, value: event.target.value as string })
      }

    const priceKey = getAdditionalDimensionPriceKey(isResale)
    const value = getAdditionalDimensionValue(additionalDimension, isResale)
    return (
      <div
        className={classes.AUDRow}
        data-testid={`additional-dimension-container-${additionalDimension.dimensionId}`}
        key={randomKey}
      >
        <Typography className={clsx(classes.labelText, classes.labelTextWidth)}>
          {additionalDimension.labelDescription ||
            additionalDimension.additionalUsageDescription}
        </Typography>
        <TextField
          id={`${additionalDimension.dimensionId}-price`}
          variant={'standard'}
          required={true}
          defaultValue={value}
          onChange={handleChange(priceKey)}
          onKeyDown={preventEventForKeys(['+', '-', 'e'])}
          type={'number'}
          className={classes.textField}
          error={!isEmpty(errors?.[priceKey] || '')}
          helperText={(errors?.[priceKey] as string) || ''}
          slotProps={{
            input: {
              inputProps: {
                min: 0,
                'data-testid': `additional-dimension-${additionalDimension.dimensionId}`,
              },
            },
          }}
        />
      </div>
    )
  }
)
